import React from "react";

function Header() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
      <div className="container">
        {/* <a className="navbar-brand logo-text page-scroll" href="index.html">
          Sync
        </a> */}

        <a className="navbar-brand logo-image" href="index.html">
          <img
            src="images/logoo.png"
            style={{
              objectFit: "cover",
              width: "15rem",
              height: "3.5rem",
            }}
            alt="alternative"
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarsExampleDefault"
          aria-controls="navbarsExampleDefault"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-awesome fas fa-bars"></span>
          <span className="navbar-toggler-awesome fas fa-times"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarsExampleDefault">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a
                className="nav-link page-scroll"
                style={{ textTransform: "uppercase" }}
                href="#description"
              >
                About <span className="sr-only">(current)</span>
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link page-scroll"
                style={{ textTransform: "uppercase" }}
                href="#features"
              >
                Features
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link page-scroll"
                style={{ textTransform: "uppercase" }}
                href="#screens"
              >
                Screens
              </a>
            </li>
          </ul>
          <span className="nav-item">
            <a
              className="btn-outline-sm page-scroll"
              style={{ textTransform: "uppercase" }}
              href="#download"
            >
              Download
            </a>
          </span>
        </div>
      </div>
    </nav>
  );
}

export default Header;
